import { Stepper } from "./components/stepper";
import { useSteps } from "./hooks/useSteps";
import { StepperBlockProps } from "./types";

export interface StepData {
  title: string;
  status: "completed" | "active" | "pending";
}

export function StepperWeb({
  theme,
  section,
  parcel,
  locale,
  defaultLocale,
}: StepperBlockProps) {
  const localeToUse = locale || defaultLocale;
  const steps = useSteps({ locale: localeToUse, parcel }).map((step) => ({
    ...step,
  }));

  if (!parcel) {
    return null;
  }

  /**
   * parcel.events[].status is a string;
   * find the last steps that matches the status: ie. that the status is included in the matches array.
   */
  const activeIndex = steps.reduceRight((acc, step, i) => {
    const event = parcel.events.find((event) =>
      step.matches.includes(event.status),
    );

    if (acc === -1 && event) {
      step.text = step.texts?.[event.status] ?? step.text;
      return i;
    }
    return acc;
  }, -1);

  if (activeIndex === -1) {
    return null;
  }

  const isDelivered = parcel.events.some((event) =>
    ["DELIVERED", "COLLECTED_AT_PICKUP", "DELIVERED_TO_NEIGHBOUR"].includes(
      event.status,
    ),
  );

  const stepperData: StepData[] = steps.map((step, index) => ({
    title: step.text ?? step.name,
    status:
      index < activeIndex
        ? "completed"
        : index === activeIndex
          ? isDelivered && step.id === "delivered"
            ? "completed"
            : "active"
          : "pending",
  }));

  return <Stepper theme={theme} section={section} steps={stepperData} />;
}
